// import React, { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import ScrollToTop from "../components/ScrollToTop";
// import { AllRoutes } from "../api/routes";
// import { FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';
// import ReactMarkdown from 'react-markdown';

// const EventDetail = () => {
//     const { slug } = useParams();
//     const [event, setEvent] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [siteSettings, setSiteSettings] = useState(null);

//     useEffect(() => {
//         window.scrollTo(0, 0);
//         AllRoutes.fetchEventDetail(slug).then(res => {
//             if (res.success) setEvent(res.data);
//             setLoading(false);
//         });
//     }, [slug]);

//     useEffect(() => {
//         AllRoutes.fetchSiteSettings().then(res => {
//             if (res.success) setSiteSettings(res.data);
//         });
//     }, []);

//     if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
//     if (!event) return <div className="min-h-screen flex items-center justify-center text-gray-500">Event not found.</div>;

//     const isCompleted = event.status === 'completed';

//     return (
//         <div className="bg-gray-50 min-h-screen">

//             {/* Hero Banner */}
//             <div
//                 className="min-h-[500px] bg-cover bg-center relative flex items-center justify-center py-16"
//                 style={{
//                     backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url("${event.banner_image}")`,
//                     backgroundAttachment: 'fixed'
//                 }}
//             >
//                 <div className="text-center px-4 max-w-3xl mx-auto">
//                     <span className={`inline-block px-4 py-1 rounded-full text-sm font-medium mb-4 ${
//                         event.status === 'ongoing' ? 'bg-green-500 text-white' :
//                         event.status === 'upcoming' ? 'bg-yellow-400 text-gray-900' :
//                         'bg-gray-400 text-white'
//                     }`}>
//                         {event.status.charAt(0).toUpperCase() + event.status.slice(1)}
//                     </span>
//                     <h1 className="text-5xl font-bold text-white mb-4">{event.title}</h1>
//                     <p className="text-gray-200 text-lg mb-4">{event.short_description}</p>
//                     <div className="flex flex-wrap justify-center gap-6 text-gray-200 text-sm mb-8">
//                         {event.event_date_display && (
//                             <span className="flex items-center gap-2">
//                                 <FaCalendarAlt className="text-blue-300" />
//                                 {event.event_date_display}
//                             </span>
//                         )}
//                         {event.venue && (
//                             <span className="flex items-center gap-2">
//                                 <FaMapMarkerAlt className="text-red-700" />
//                                 {event.venue}
//                             </span>
//                         )}
//                     </div>
//                     {event.day_schedule && event.day_schedule.length > 0 && (
//                         <div className="mt-8 bg-white/10 backdrop-blur-md rounded-2xl p-6 max-w-2xl mx-auto border border-white/20">
//                             <h3 className="text-white font-bold text-lg mb-4 text-center">Event Schedule</h3>
//                             <div className="divide-y divide-white/20">
//                                 {event.day_schedule.map((item, idx) => (
//                                     <div key={idx} className="flex items-center justify-between py-3 gap-6">
//                                         <span className=" text-white text-sm font-semibold px-3 py-1 rounded-lg whitespace-nowrap">
//                                             {item.time_slot}
//                                         </span>
//                                         <span className="text-white/90 text-sm text-right">{item.activity}</span>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     )}
//                     <div className="flex gap-4 justify-center flex-wrap mt-4">
//                         {event.status === 'upcoming' && event.kaggle_link && (
//                             <a href={event.kaggle_link} target="_blank" rel="noreferrer"
//                                 className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors text-lg">
//                                 Join the Challenge →
//                             </a>
//                         )}
//                         {event.status === 'ongoing' && event.kaggle_leaderboard_link && (
//                             <a href={event.kaggle_leaderboard_link} target="_blank" rel="noreferrer"
//                                 className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors text-lg">
//                                 View Leaderboard →
//                             </a>
//                         )}
//                         {isCompleted && event.kaggle_leaderboard_link && (
//                             <a href={event.kaggle_leaderboard_link} target="_blank" rel="noreferrer"
//                                 className="bg-gray-600 hover:bg-gray-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors text-lg">
//                                 View on Kaggle →
//                             </a>
//                         )}
//                         <Link to="/events"
//                             className="bg-white/20 hover:bg-white/30 text-white font-semibold px-6 py-3 rounded-lg transition-colors text-lg">
//                             ← All Events
//                         </Link>
//                     </div>
//                 </div>
//             </div>

//             {/* Sticky Navbar */}
//             <nav className="sticky top-20 bg-white shadow-md z-20">
//                 <div className="container mx-auto px-4 flex gap-8 py-3 overflow-x-auto">
//                     {[
//                         { id: 'about', label: 'about' },
//                         ...(event.sections || []).map((section, idx) => ({
//                             id: `section-${idx}`,
//                             label: section.title,
//                         })),
//                         event.timeline && event.timeline.length > 0 && { id: 'timeline', label: 'timeline' },
//                         isCompleted && event.winners && event.winners.length > 0 && { id: 'leaderboard', label: 'leaderboard' },
//                         event.organizers && event.organizers.length > 0 && { id: 'organizers', label: 'organizers' },
//                         event.sponsors && event.sponsors.length > 0 && { id: 'sponsors', label: 'sponsors' },
//                         siteSettings?.code_of_conduct && { id: 'code-of-conduct', label: 'code of conduct' },
//                     ]
//                         .filter(Boolean)
//                         .map(item => (
//                             <a key={item.id} href={`#${item.id}`}
//                                 className="text-gray-600 hover:text-blue-600 font-medium capitalize whitespace-nowrap transition-colors">
//                                 {item.label}
//                             </a>
//                         ))}
//                 </div>
//             </nav>
            

//             {/* About */}
//             <section id="about" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-36">
//                 <h2 className="text-3xl font-bold text-gray-900 mb-6">About</h2>
//                 <p className="text-gray-600 leading-relaxed text-lg whitespace-pre-line">{event.about}</p>
//             </section>

//             <hr className="max-w-4xl mx-auto border-gray-200" />
//                         {/* custom sections */}
//             {event.sections && event.sections.length > 0 && event.sections.map((section, idx) => (
//                 <React.Fragment key={idx}>
//                     <hr className="max-w-4xl mx-auto border-gray-200" />
//                     <section id={`section-${idx}`} className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-40">
//                         <h2 className="text-3xl font-bold text-gray-900 mb-6">{section.title}</h2>
//                         <div className="prose prose-lg max-w-none text-gray-600">
//                             <ReactMarkdown>{section.content}</ReactMarkdown>
//                         </div>
//                     </section>
//                 </React.Fragment>
//             ))}


//             {/* Timeline */}
//             {event.timeline && event.timeline.length > 0 && (
//                 <section id="timeline" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-40">
//                     <h2 className="text-3xl font-bold text-gray-900 mb-10">Schedule</h2>
//                     <div className="relative border-l-2 border-blue-200 ml-4">
//                         {event.timeline.map((event, idx) => (
//                             <div key={idx} className="mb-8 ml-8 relative">
//                                 <div className="absolute -left-11 w-4 h-4 bg-blue-600 rounded-full border-2 border-white shadow" />
//                                 <p className="text-sm text-blue-600 font-medium mb-1">{event.date}</p>
//                                 <h3 className="text-lg font-semibold text-gray-900">{event.title}</h3>
//                                 {event.description && <p className="text-gray-600 text-sm mt-1">{event.description}</p>}
//                             </div>
//                         ))}
//                     </div>
//                 </section>
//             )}

//             {/* Leaderboard — only when completed */}
//             {isCompleted && event.winners && event.winners.length > 0 && (
//                 <>
//                     <hr className="max-w-4xl mx-auto border-gray-200" />
//                     <section id="leaderboard" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-36">
//                         <h2 className="text-3xl font-bold text-gray-900 mb-10">Leaderboard</h2>
//                         <div className="overflow-x-auto rounded-xl shadow">
//                             <table className="w-full text-left bg-white">
//                                 <thead className="bg-blue-600 text-white">
//                                     <tr>
//                                         <th className="px-6 py-4">Rank</th>
//                                         <th className="px-6 py-4">{event.is_team_event ? 'Team' : 'Participant'}</th>
//                                         {event.is_team_event && <th className="px-6 py-4">Members</th>}
//                                         <th className="px-6 py-4">Score</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {event.winners.map((winner, idx) => (
//                                         <tr key={idx} className={`border-t ${idx === 0 ? 'bg-yellow-50' : idx === 1 ? 'bg-gray-50' : idx === 2 ? 'bg-orange-50' : ''}`}>
//                                             <td className="px-6 py-4 font-bold text-lg">
//                                                 {idx === 0 ? '🥇' : idx === 1 ? '🥈' : idx === 2 ? '🥉' : `#${winner.rank}`}
//                                             </td>
//                                             <td className="px-6 py-4 font-medium text-gray-900">{winner.name}</td>
//                                             {event.is_team_event && (
//                                                 <td className="px-6 py-4 text-gray-500 text-sm">{winner.members}</td>
//                                             )}
//                                             <td className="px-6 py-4 text-blue-600 font-semibold">{winner.score}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </section>
//                 </>
//             )}

//             <hr className="max-w-4xl mx-auto border-gray-200" />

//             {/* Organizers */}
//             {event.organizers && event.organizers.length > 0 && (
//                 <section id="organizers" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-36">
//                     <h2 className="text-3xl font-bold text-gray-900 mb-10">Organizers</h2>
//                     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
//                         {event.organizers.map((org, idx) => (
//                             <a key={idx} href={org.link || '#'} target="_blank" rel="noreferrer"
//                                 className="flex flex-col items-center text-center group">
//                                 {org.image ? (
//                                     <img src={org.image} alt={org.name}
//                                         className="w-36 h-36 rounded-full object-cover mb-3 shadow-md group-hover:shadow-lg transition-shadow" />
//                                 ) : (
//                                     <div className="w-24 h-24 rounded-full bg-blue-100 flex items-center justify-center mb-3 text-blue-600 text-2xl font-bold">
//                                         {org.name.charAt(0)}
//                                     </div>
//                                 )}
//                                 <p className="font-semibold text-gray-900 text-lg">{org.name}</p>
//                                 <p className="text-gray-600 text-sm mt-1">{org.role}</p>
//                             </a>
//                         ))}
//                     </div>
//                 </section>
//             )}

//             {/* Sponsors */}
//             {event.sponsors && event.sponsors.length > 0 && (
//                 <>
//                     <hr className="max-w-4xl mx-auto border-gray-200" />
//                     <section id="sponsors" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-36">
//                         <h2 className="text-3xl font-bold text-gray-900 mb-10">Sponsors</h2>
//                         <div className="flex flex-wrap justify-center gap-8">
//                             {event.sponsors.map((sponsor, idx) => (
//                                 <a key={idx} href={sponsor.link || '#'} target="_blank" rel="noreferrer"
//                                     className="flex flex-col items-center text-center group">
//                                     {sponsor.logo ? (
//                                         <img src={sponsor.logo} alt={sponsor.name}
//                                             className="h-16 object-contain mb-2 grayscale group-hover:grayscale-0 transition-all" />
//                                     ) : (
//                                         <div className="h-16 px-6 bg-gray-100 rounded-lg flex items-center justify-center mb-2 text-gray-700 font-bold text-lg">
//                                             {sponsor.name}
//                                         </div>
//                                     )}
//                                     {sponsor.tier && (
//                                         <span className="text-xs text-gray-400">{sponsor.tier}</span>
//                                     )}
//                                 </a>
//                             ))}
//                         </div>
//                     </section>
//                 </>
//             )}
//             {siteSettings?.code_of_conduct && (
//                 <>
//                     <hr className="max-w-4xl mx-auto border-gray-200" />
//                     <section id="code-of-conduct" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-36">
//                         <h2 className="text-3xl font-bold text-gray-900 mb-6">Code of Conduct</h2>
//                         <div className="bg-white rounded-xl shadow p-8">
//                             <p className="text-gray-600 leading-relaxed whitespace-pre-line">
//                                 {siteSettings.code_of_conduct}
//                             </p>
//                         </div>
//                     </section>
//                 </>
//             )}

//             <ScrollToTop />
//         </div>
//     );
// };

// export default EventDetail;

import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import { AllRoutes } from "../api/routes";
import { FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';
import ReactMarkdown from 'react-markdown';

const EventDetail = () => {
    const { slug } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [siteSettings, setSiteSettings] = useState(null);
    const [activeSection, setActiveSection] = useState('about');

    useEffect(() => {
        window.scrollTo(0, 0);
        AllRoutes.fetchEventDetail(slug).then(res => {
            if (res.success) setEvent(res.data);
            setLoading(false);
        });
    }, [slug]);

    useEffect(() => {
        AllRoutes.fetchSiteSettings().then(res => {
            if (res.success) setSiteSettings(res.data);
        });
    }, []);

    const isCompleted = event?.status === 'completed';

    // Build nav items once per event/settings change instead of every render
    const navItems = useMemo(() => {
        if (!event) return [];
        return [
            { id: 'about', label: 'about' },
            ...(event.sections || []).map((section, idx) => ({
                id: `section-${idx}`,
                label: section.title,
            })),
            event.timeline?.length > 0 && { id: 'timeline', label: 'timeline' },
            isCompleted && event.winners?.length > 0 && { id: 'leaderboard', label: 'leaderboard' },
            event.organizers?.length > 0 && { id: 'organizers', label: 'organizers' },
            event.sponsors?.length > 0 && { id: 'sponsors', label: 'sponsors/collaborators' },
            siteSettings?.code_of_conduct && { id: 'code-of-conduct', label: 'code of conduct' },
        ].filter(Boolean);
    }, [event, siteSettings, isCompleted]);

    const navItemRefs = useRef({});
    // Scroll-spy: highlight whichever section is currently under the sticky nav
    useEffect(() => {
        if (!navItems.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            { rootMargin: '-140px 0px -65% 0px', threshold: 0 }
        );

        navItems.forEach(item => {
            const el = document.getElementById(item.id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [navItems]);

    useEffect(() => {
    const activeEl = navItemRefs.current[activeSection];
    if (activeEl) {
        activeEl.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
        });
    }
}, [activeSection]);

    if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
    if (!event) return <div className="min-h-screen flex items-center justify-center text-gray-500">Event not found.</div>;

    return (
        <div className="bg-gray-50 min-h-screen">

            {/* Hero Banner */}
            <div
                className="min-h-[500px] bg-cover bg-center relative flex items-center justify-center py-16"
                style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url("${event.banner_image}")`,
                    backgroundAttachment: 'fixed'
                }}
            >
                <div className="text-center px-4 max-w-3xl mx-auto">
                    <span className={`inline-block px-4 py-1 rounded-full text-sm font-medium mb-4 ${
                        event.status === 'ongoing' ? 'bg-green-500 text-white' :
                        event.status === 'upcoming' ? 'bg-yellow-400 text-gray-900' :
                        'bg-gray-400 text-white'
                    }`}>
                        {event.status.charAt(0).toUpperCase() + event.status.slice(1)}
                    </span>
                    <h1 className="text-5xl font-bold text-white mb-4">{event.title}</h1>
                    <p className="text-gray-200 text-lg mb-4">{event.short_description}</p>
                    <div className="flex flex-wrap justify-center gap-6 text-gray-200 text-sm mb-8">
                        {event.event_date_display && (
                            <span className="flex items-center gap-2">
                                <FaCalendarAlt className="text-blue-300" />
                                {event.event_date_display}
                            </span>
                        )}
                        {event.venue && (
                            <span className="flex items-center gap-2">
                                <FaMapMarkerAlt className="text-red-700" />
                                {event.venue}
                            </span>
                        )}
                    </div>
                    {event.day_schedule && event.day_schedule.length > 0 && (
                        <div className="mt-8 bg-white/10 backdrop-blur-md rounded-2xl p-6 max-w-2xl mx-auto border border-white/20">
                            <h3 className="text-white font-bold text-lg mb-4 text-center">Event Schedule</h3>
                            <div className="divide-y divide-white/20">
                                {event.day_schedule.map((item, idx) => (
                                    <div key={idx} className="flex items-center justify-between py-3 gap-6">
                                        <span className=" text-white text-sm font-semibold px-3 py-1 rounded-lg whitespace-nowrap">
                                            {item.time_slot}
                                        </span>
                                        <span className="text-white/90 text-sm text-right">{item.activity}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="flex gap-4 justify-center flex-wrap mt-4">
                        {event.status === 'upcoming' && event.kaggle_link && (
                            <a href={event.kaggle_link} target="_blank" rel="noreferrer"
                                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors text-lg">
                                Join the Challenge →
                            </a>
                        )}
                        {event.status === 'ongoing' && event.kaggle_leaderboard_link && (
                            <a href={event.kaggle_leaderboard_link} target="_blank" rel="noreferrer"
                                className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors text-lg">
                                View Leaderboard →
                            </a>
                        )}
                        {isCompleted && event.kaggle_leaderboard_link && (
                            <a href={event.kaggle_leaderboard_link} target="_blank" rel="noreferrer"
                                className="bg-gray-600 hover:bg-gray-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors text-lg">
                                View on Kaggle →
                            </a>
                        )}
                        <Link to="/events"
                            className="bg-white/20 hover:bg-white/30 text-white font-semibold px-6 py-3 rounded-lg transition-colors text-lg">
                            ← All Events
                        </Link>
                    </div>
                </div>
            </div>

            {/* Sticky Navbar — glassy pill nav with scroll-spy */}
            <nav className="sticky top-20 z-20 bg-white/80 backdrop-blur-md border-b border-gray-200/70">
                <div className="container mx-auto px-4">
                    <div
                        className="overflow-x-auto
                                [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden
                                [mask-image:linear-gradient(to_right,transparent,black_20px,black_calc(100%-20px),transparent)]"
                    >
                        <div className="flex justify-center gap-1 py-2.5 w-max min-w-full mx-auto">
                            {navItems.map(item => {
                                const isActive = activeSection === item.id;
                                return (
                                    <a
                                        key={item.id}
                                        ref={(el) => { navItemRefs.current[item.id] = el; }}
                                        href={`#${item.id}`}
                                        className={`shrink-0 px-4 py-1.5 rounded-full text-sm font-medium capitalize whitespace-nowrap transition-colors ${
                                            isActive
                                                ? 'bg-blue-600 text-white'
                                                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'
                                        }`}
                                    >
                                        {item.label}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </nav>

            {/* About */}
            <section id="about" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-32">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">About</h2>
                <p className="text-gray-600 leading-relaxed text-lg whitespace-pre-line">{event.about}</p>
            </section>

            <hr className="max-w-4xl mx-auto border-gray-200" />

            {/* custom sections */}
            {event.sections && event.sections.length > 0 && event.sections.map((section, idx) => (
                <React.Fragment key={idx}>
                    <section id={`section-${idx}`} className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-32">
                        <h2 className="text-3xl font-bold text-gray-900 mb-6">{section.title}</h2>
                        <div className="prose prose-lg max-w-none text-gray-600">
                            <ReactMarkdown>{section.content}</ReactMarkdown>
                        </div>
                    </section>
                    <hr className="max-w-4xl mx-auto border-gray-200" />
                </React.Fragment>
            ))}

            {/* Timeline */}
            {event.timeline && event.timeline.length > 0 && (
                <section id="timeline" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-32">
                    <h2 className="text-3xl font-bold text-gray-900 mb-10">Schedule</h2>
                    <div className="relative border-l-2 border-blue-200 ml-4">
                        {event.timeline.map((tItem, idx) => (
                            <div key={idx} className="mb-8 ml-8 relative">
                                <div className="absolute -left-11 w-4 h-4 bg-blue-600 rounded-full border-2 border-white shadow" />
                                <p className="text-sm text-blue-600 font-medium mb-1">{tItem.date}</p>
                                <h3 className="text-lg font-semibold text-gray-900">{tItem.title}</h3>
                                {tItem.description && <p className="text-gray-600 text-sm mt-1">{tItem.description}</p>}
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {/* Leaderboard — only when completed */}
            {isCompleted && event.winners && event.winners.length > 0 && (
                <>
                    <hr className="max-w-4xl mx-auto border-gray-200" />
                    <section id="leaderboard" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-32">
                        <h2 className="text-3xl font-bold text-gray-900 mb-10">Leaderboard</h2>
                        <div className="overflow-x-auto rounded-xl shadow">
                            <table className="w-full text-left bg-white">
                                <thead className="bg-blue-600 text-white">
                                    <tr>
                                        <th className="px-6 py-4">Rank</th>
                                        <th className="px-6 py-4">{event.is_team_event ? 'Team' : 'Participant'}</th>
                                        {event.is_team_event && <th className="px-6 py-4">Members</th>}
                                        <th className="px-6 py-4">Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {event.winners.map((winner, idx) => (
                                        <tr key={idx} className={`border-t ${idx === 0 ? 'bg-yellow-50' : idx === 1 ? 'bg-gray-50' : idx === 2 ? 'bg-orange-50' : ''}`}>
                                            <td className="px-6 py-4 font-bold text-lg">
                                                {idx === 0 ? '🥇' : idx === 1 ? '🥈' : idx === 2 ? '🥉' : `#${winner.rank}`}
                                            </td>
                                            <td className="px-6 py-4 font-medium text-gray-900">{winner.name}</td>
                                            {event.is_team_event && (
                                                <td className="px-6 py-4 text-gray-500 text-sm">{winner.members}</td>
                                            )}
                                            <td className="px-6 py-4 text-blue-600 font-semibold">{winner.score}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </>
            )}

            <hr className="max-w-4xl mx-auto border-gray-200" />

            {/* Organizers */}
            {event.organizers && event.organizers.length > 0 && (
                <section id="organizers" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-32">
                    <h2 className="text-3xl font-bold text-gray-900 mb-10">Organizers</h2>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                        {event.organizers.map((org, idx) => (
                            <a key={idx} href={org.link || '#'} target="_blank" rel="noreferrer"
                                className="flex flex-col items-center text-center group">
                                {org.image ? (
                                    <img src={org.image} alt={org.name}
                                        className="w-36 h-36 rounded-full object-cover mb-3 shadow-md group-hover:shadow-lg transition-shadow" />
                                ) : (
                                    <div className="w-24 h-24 rounded-full bg-blue-100 flex items-center justify-center mb-3 text-blue-600 text-2xl font-bold">
                                        {org.name.charAt(0)}
                                    </div>
                                )}
                                <p className="font-semibold text-gray-900 text-lg">{org.name}</p>
                                <p className="text-gray-600 text-sm mt-1">{org.role}</p>
                            </a>
                        ))}
                    </div>
                </section>
            )}

            {/* Sponsors */}
            {event.sponsors && event.sponsors.length > 0 && (
                <>
                    <hr className="max-w-4xl mx-auto border-gray-200" />
                    <section id="sponsors" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-32">
                        <h2 className="text-3xl font-bold text-gray-900 mb-10">Sponsor/Collaborators</h2>
                        <div className="flex flex-wrap justify-center gap-8">
                            {event.sponsors.map((sponsor, idx) => (
                                <a key={idx} href={sponsor.link || '#'} target="_blank" rel="noreferrer"
                                    className="flex flex-col items-center text-center group">
                                    {sponsor.logo ? (
                                        <img src={sponsor.logo} alt={sponsor.name}
                                            className="h-16 object-contain mb-2 grayscale group-hover:grayscale-0 transition-all" />
                                    ) : (
                                        <div className="h-16 px-6 bg-gray-100 rounded-lg flex items-center justify-center mb-2 text-gray-700 font-bold text-lg">
                                            {sponsor.name}
                                        </div>
                                    )}
                                    {sponsor.tier && (
                                        <span className="text-xs text-gray-400">{sponsor.tier}</span>
                                    )}
                                </a>
                            ))}
                        </div>
                    </section>
                </>
            )}

            {siteSettings?.code_of_conduct && (
                <>
                    <hr className="max-w-4xl mx-auto border-gray-200" />
                    <section id="code-of-conduct" className="container mx-auto px-4 py-16 max-w-4xl scroll-mt-32">
                        <h2 className="text-3xl font-bold text-gray-900 mb-6">Code of Conduct</h2>
                        <div className="bg-white rounded-xl shadow p-8">
                            <p className="text-gray-600 leading-relaxed whitespace-pre-line">
                                {siteSettings.code_of_conduct}
                            </p>
                        </div>
                    </section>
                </>
            )}

            <ScrollToTop />
        </div>
    );
};

export default EventDetail;